import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

import { Flex, Text } from 'components/primitives'

type InfoSubtitleProps = {
  infoText: string | React.ReactNode
  color?: string
  iconColor?: string
}

const InfoSubtitle = ({
  infoText,
  color = '$subtitleGrey',
  iconColor = '',
}: InfoSubtitleProps) => (
  <Flex align="center" justify="center" css={{ pt: '$2', gap: '$1' }}>
    <FontAwesomeIcon
      color={iconColor}
      icon={faInfoCircle}
      width="12.5"
      height="12.5"
    />
    <Text css={{ color, fontSize: 12, fontWeight: 400 }}>{infoText}</Text>
  </Flex>
)

export default InfoSubtitle
